import { render } from "./VoteCardControl.vue?vue&type=template&id=459fc744&scoped=true"
import script from "./VoteCardControl.vue?vue&type=script&lang=js"
export * from "./VoteCardControl.vue?vue&type=script&lang=js"

import "./VoteCardControl.vue?vue&type=style&index=0&id=459fc744&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459fc744"]])

export default __exports__